import { getCookie } from '@lhb/cache';
import { deepCopy } from '@lhb/func';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
const defaultTheme = getCookie('location-theme'); // 预存，避免每次都有切换主题的体验
interface InitStata {
  number: number;
  provinceCityDistrict: any[]; // 省市区
  provincesCities: any[]; // 省市
  citiesWithEN: any[]; // 带有拼音的城市列表
  tenantInfo: any; // 租户详情
  /** 当前用户信息 */
  currentUserInfo: any;
  /** 当前租户的检查信息 tenantCheckInfo */
  tenantCheck: any;
  // 专供高德地图的城市数据，数据格式
  // [{name: 城市名称, id: 城市id, provinceName: 所属省份名称, provinceId: 所属省份id, district: [] 区数据}]
  cityForAMap: any[];
  dynamicOtherFormNameArr:string[];
  theme: string; // 用户自定义的主题模型
}

const initialState: InitStata = {
  provinceCityDistrict: [], // 省市区
  provincesCities: [], // 省市
  citiesWithEN: [], // 带有拼音的城市列表
  cityForAMap: [], // 专供高德地图的城市数据，数据格式
  number: 0,
  /** 当前用户信息 */
  currentUserInfo: null,
  /** 当前租户的详情信息，初始化空对象时将获取数据 */
  tenantInfo: {},
  /** 当前租户的检查信息 tenantCheckInfo，初始化空对象时将获取数据 */
  tenantCheck: {},
  dynamicOtherFormNameArr: [], // 存放“其他”表单的formName
  theme: defaultTheme,
};

const customerSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    changeProvinceCityDistrict: (state = initialState, action: PayloadAction<any[]>) => {
      const _cityForAMap: any[] = [];
      // 禁选特殊的行政区
      state.provinceCityDistrict = action.payload.map((item: any) => {
        if (['台湾', '香港', '澳门'].some(region => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
            city.children?.forEach(district => {
              district.disabled = true;
            });
            // cityForAMap数据组装
            _cityForAMap.push({
              name: city.name,
              id: city.id,
              code: city.code,
              lng: city.lng,
              lat: city.lat,
              provinceLng: item.lng,
              provinceLat: item.lat,
              provinceName: item.name,
              provinceId: item.id,
              provinceCode: item.code,
              district: city.children,
              disabled: true,
              pinyin: item.pinyin// 省份的拼音
            });
          });
          return {
            ...item,
            disabled: true
          };
        }
        // cityForAMap数据组装
        item.children?.forEach(city => {
          _cityForAMap.push({
            name: city.name,
            id: city.id,
            lng: city.lng,
            lat: city.lat,
            provinceLng: item.lng,
            provinceLat: item.lat,
            code: city.code, // 对应高德数据中城市的adcode
            provinceName: item.name,
            provinceId: item.id,
            provinceCode: item.code, // 对应高德数据中省份的adcode
            district: city.children,
            pinyin: item.pinyin// 省份的拼音
          });
        });
        return item;
      });
      state.cityForAMap = _cityForAMap;
    },
    changeProvincesCities: (state = initialState, action: PayloadAction<any[]>) => {
      state.provincesCities = action.payload.map((item: any) => {
        if (['台湾', '香港', '澳门'].some(region => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
          });
          return {
            ...item,
            disabled: true
          };
        }
        return item;
      });
    },
    changeTenantInfo: (state = initialState, action: PayloadAction<any>) => {
      state.tenantInfo = action.payload;
    },
    changeTheme: (state = initialState, action: PayloadAction<any>) => {
      state.theme = action.payload;
    },

    /** 更新当前用户信息 */
    UPDATE_CURRENT_USER_INFO(state: any, action: any) {
      state.currentUserInfo = deepCopy(action.payload || {});
    },

    /** 更新当前租户的检查信息 */
    UPDATE_TENANT_CHECK_INFO: (state = initialState, action: PayloadAction<any>) => {
      const payload = deepCopy(action.payload || {});
      state.tenantCheck = {
        ...payload,
        isCircleTask: ['clusterA', 'clusterB', 'clusterC'].includes(payload.taskTemplateCode)
      };
    },
    changeDynamicOtherFormNameArr: (state = initialState, action: PayloadAction<any>) => {
      state.dynamicOtherFormNameArr = action.payload;
    },
    changeCitiesWithEN: (
      state = initialState,
      action: PayloadAction<any[]>,
    ) => {
      state.citiesWithEN = action.payload.map((item: any) => {
        if (['台北', '香港', '澳门'].some((region) => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
          });
          return {
            ...item,
            disabled: true
          };
        }
        return item;
      });
    },
  },
});

// 导出action
export const {
  changeCount,
  changeProvincesCities,
  changeProvinceCityDistrict,
  changeTenantInfo,
  changeTheme,
  UPDATE_CURRENT_USER_INFO,
  UPDATE_TENANT_CHECK_INFO,
  changeDynamicOtherFormNameArr,
  changeCitiesWithEN
} = customerSlice.actions;

export default customerSlice.reducer;
